import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { LocalStorageService } from '../shared/services/local-storage.service';


@Injectable({
    providedIn: 'root',
  })
  export class AuthGuard implements CanActivate {
    constructor(private router:Router, private localStorageService: LocalStorageService){}
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot):
      | Observable<boolean | UrlTree>
      | Promise<boolean | UrlTree>
      | boolean
      | UrlTree {
	      const token = this.localStorageService.getToken();
	      // Auth is controlled by backend session token; wallet presence can hydrate later after refresh.
	      if (token) {
	        return true;
	      } else {
        // Preserve intended deep-link so wallet-connect can return after signature login.
        if (state?.url) {
          localStorage.setItem('currentUrl', state.url);
        }
        // Always route unauthenticated access through wallet-connect first.
        this.router.navigate(['/wallet-connect']);
        return false;
      }
    }
  }


  @Injectable({ providedIn: 'root' })
 export class NoAuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private localStorageService: LocalStorageService
  ) {}

	  canActivate(
	    route: ActivatedRouteSnapshot,
	    state: RouterStateSnapshot
	  ): boolean {
	    const token = this.localStorageService.getToken();
	    // console.log('token', token);
	    if (token) {
	      // If the user is already authenticated, send them to /allocation-details
	      this.router.navigate(['/user-dashboard']);
	      return false;
	    } else {
	      return true;
	    }
	  }
	}




@Injectable({
  providedIn: 'root'
})
export class BugBountyAuthGuard implements CanActivate {

  constructor( private router: Router,    private localStorageService: LocalStorageService
) {}

  async canActivate(): Promise<boolean | UrlTree> {

    if (this.localStorageService.getDataByKey('is_bounty_user')) {
      return true; 
    } else {
      return this.router.createUrlTree(['/bug-bounty/participation']); // not logged in -> redirect
    }
  }
}



@Injectable({
  providedIn: 'root'
})
export class BugBountyNoAuthGuard implements CanActivate {

  constructor( private router: Router,    private localStorageService: LocalStorageService
) {}

  async canActivate(): Promise<boolean | UrlTree> {

    if (this.localStorageService.getDataByKey('is_bounty_user')==false) {
      return true; 
    } else {
      return this.router.createUrlTree(['/bug-bounty/form']); // not logged in -> redirect
    }
  }
}


@Injectable({
  providedIn: 'root'
})
export class SAFAuthGuard implements CanActivate {

  constructor( private router: Router,    private localStorageService: LocalStorageService
) {}

  async canActivate(): Promise<boolean | UrlTree> {

    if (this.localStorageService.getDataByKey('isAfricaUser')) {
      return true; 
    } else {
      return this.router.createUrlTree(['']);
    }
  }
}


@Injectable({
  providedIn: 'root'
})
export class SAFManifestAuthGuard implements CanActivate {

  constructor( private router: Router,    private localStorageService: LocalStorageService
) {}

  async canActivate(): Promise<boolean | UrlTree> {

    if (this.localStorageService.getDataByKey('is_manifestation_user')) {
      return true; 
    } else {
      return this.router.createUrlTree(['']);
    }
  }
}
